import React, { useState, useRef } from 'react'
import { TabTitle } from '../../utils/GeneralFunction';
import PageHeader from '../../components/PageHeader/PageHeader';
import { Button, Form, Input, Table, Spin, Tag } from 'antd';
import { Row as Brow, Col as Bcol } from "reactstrap";
import { CSVLink } from "react-csv";
import moment from 'moment';
import * as XLSX from "xlsx";
import { BASEURL } from '../../constant/config';
import { ReadCookie } from '../../utils/readCookie';
import axios from 'axios';
import Swal from "sweetalert2";

const AutoInvoice = () => {
    TabTitle("Auto-Invoice")
    const [form] = Form.useForm();
    const tableRef = useRef(null);
    const token = ReadCookie("token");
    const [minimize, setMinimize] = useState(false);
    const [excelFile, setExcelFile] = useState(null);
    const [excelFileError, setExcelFileError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const onFinish = async () => {
        // setLoading(true);
        await form.validateFields().then((values) => {


            // dispatch(getPendingPodSummary(token, values)).then((res) => {
            //     setToogle(true);
            //     setLoading(false);
            //     setPendingSummaryList(res?.payload?.data);
            //     downloadExcelFileData(res?.payload?.data);
            // });
        }).catch((error) => {
            // setLoading(false);
        })
    }

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: 'PT #',
            dataIndex: 'ptno',
            key: 'ptno',
            // render: (text, record) => (
            //     <Link style={{ color: "#0d6efd", textDecoration: "underline" }}
            //         to={"/order-shipment?mode=edit&order_id=" + record.ship_header_id + "&customer_id/" + record.customer_id + "?edit=yes"}
            //     >
            //         {text}
            //     </Link>
            // ),
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (text, record) => (
                moment(text).format("MM-DD-YYYY")
            ),
        },
        {
            title: 'Invoice No',
            dataIndex: 'invoice_no',
            key: 'invoice_no',
            render: (text, record) => (
                text
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => (
                text === 'Success' ? <Tag color="green">{text}</Tag> :
                    text === 'Failed' ? <Tag color="red">{text}</Tag> :
                        ""
            ),
        },
        {
            title: 'Already',
            dataIndex: 'already_created',
            key: 'already_created',
            render: (text, record) => (
                text ? <Tag color={"green"}>{"True"}</Tag> : <Tag color={"red"}>{"False"}</Tag>
            ),
        },
    ]


    const handleFile = (e) => {
        let selectedFile = e.target.files[0];
        if (selectedFile) {

            // if (selectedFile && fileType.includes(selectedFile.type)) {
            let reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);

            reader.onload = (e) => {
                setExcelFileError(null);
                setExcelFile(e.target.result);
            };
            // } else {
            //   setExcelFile(null);
            //   setExcelFileError("Please select only excel file types");
            // }
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (excelFile !== null) {
            setLoading(true);
            const workbook = XLSX.read(excelFile, {
                type: "buffer",
                cellDates: true
            });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const exceldata = XLSX.utils.sheet_to_json(worksheet, { raw: false })

            if (exceldata.length > 0) {
                setData(exceldata);
            } else {
                setData([]);
            }
            setLoading(false);
            setExcelFile(null);

        }
    };


    const generateInvoices = async () => {
        try {
            setLoading(true);

            for (const item of data) {
                const response = await axios({
                    method: "POST",
                    url: `${BASEURL}create/AutoInvoice`,
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + token,
                    },
                    data: { ship_header_no: item.ptno, invoice_date: moment(item.date).format("MM-DD-YYYY") },
                });

                if (response.status === 200) {
                    // React state ko update karna
                    setData(prevData =>
                        prevData.map(d => {
                            if (d.ptno === response.data.ship_header_no) {
                                return {
                                    ...d,
                                    invoice_no: response.data.create_auto_invoice,
                                    status: response.data.success ? "Success" : "Failed",
                                    already_created: response.data.already_created,
                                };
                            }
                            return d;
                        })
                    );
                }
            }

            console.log("All invoices generated successfully.");
        } catch (error) {
            Swal.fire({ icon: "error", title: "Oops...", text: "SomeThing Went Wrong!" });
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="styleBodyPendingSummary">
            <PageHeader
                title={"Auto-Invoice"}
                minimize={setMinimize}
                check={minimize}
            />
            <div style={{ padding: 10 }} className="bodyStyle">
                <Form onFinish={onFinish} form={form} name="control-hooks">
                    <div className="container-fluid pbpx-5 ptpx-5">
                        <Brow>

                            <Bcol lg={6} xxl={3}>
                                <div className="firstSectionRo">
                                    <Form.Item >
                                        <Input
                                            type="file"
                                            ClassName="form-control"
                                            onChange={handleFile}
                                        // disabled={
                                        //     !(formState === "add" || formState === "edit")
                                        // }
                                        />
                                        {excelFileError && (
                                            <div className="text-danger">{excelFileError}</div>
                                        )}
                                    </Form.Item>
                                </div>
                                {/* <Button type="submit" className="btn btn-success" style={{ marginTop: 5 + 'px' }} onClick={handleSubmit}>Submit</Button> */}
                            </Bcol>
                            <Bcol lg={6} xxl={1}>
                                <div style={{ display: "flex", gap: 20 }}>
                                    <Button
                                        type="submit"
                                        className="btn btn-success"
                                        style={{ marginTop: 5 + "px" }}
                                        onClick={handleSubmit}
                                        disabled={excelFile === null}
                                    >
                                        File Submit
                                    </Button>
                                    <Button
                                        type="submit"
                                        className="btn btn-success"
                                        style={{ marginTop: 5 + "px" }}
                                        onClick={generateInvoices}
                                        disabled={data.length === 0 || data.some(d => d.status)}
                                    >
                                        Generate Invoices
                                    </Button>
                                </div>
                            </Bcol>




                        </Brow>
                    </div>
                </Form>
                {/* <Button
                    htmlType="submit"
                    type="primary"
                    className="submit-btn-btm "
                    onClick={onFinish}
                >
                    Submit
                </Button> */}
            </div>
            <div style={{ padding: 10 }}>
                {
                    false ? (
                        <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
                            <Spin size='large' />
                        </div>
                    ) : (
                        true > 0 ? (
                            <Table
                                title={() =>
                                    data.length > 0 && (
                                        <CSVLink
                                            filename={"Auto-Invoice.csv"}
                                            data={data.length > 0 ?
                                                data.map((v) => {
                                                    return {
                                                        "Pt No": v.ptno,
                                                        "Date": moment(v.date).format("MM-DD-YY"),
                                                        "Invoice No": v.invoice_no,
                                                        "Status": v.status === "Success" ? "Success" : v.status === "Failed" ? "Failed" : "",
                                                        "Already": v.already_created ? "True" : "False",
                                                    };
                                                })
                                                : []}
                                        // onClick={() => {
                                        // }}
                                        >
                                            Download Excel
                                        </CSVLink>
                                    )
                                }
                                ref={tableRef}
                                size="small"
                                bordered={false}
                                type="company"
                                scroll={{
                                    x: 'max-content',
                                }}
                                pagination={{
                                    defaultCurrent: 1,
                                    defaultPageSize: 100,
                                    pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                                }}

                                dataSource={data.length > 0 ? data : []}
                                columns={columns}
                                loading={loading}
                                paginate
                            />
                        ) : <div
                            style={{
                                backgroundColor: "#CCCCCC",
                                borderWidth: "1pt",
                                borderStyle: "Dashed",
                                fontWeight: "bold",
                                height: "25px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            No record(s)
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default AutoInvoice;